import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "8",
  fill: "none",
  viewBox: "0 0 14 8"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "m.875.875 6 6 6-6"
    }, null, -1)
  ])]);
}
const ChevronDownIcon = { render };
export {
  ChevronDownIcon as default,
  render
};
//# sourceMappingURL=chevron-down.svg.js.map
